import { useScrollReveal } from "@/hooks/useScrollReveal";
import SectionTitle from "./SectionTitle";

const steps = [
  {
    step: "STEP 1",
    title: "座学研修",
    desc: "警備の基本知識・法令・現場マナーを学びます",
  },
  {
    step: "STEP 2",
    title: "実技研修",
    desc: "誘導灯の振り方など実践スキルを習得します",
  },
  {
    step: "STEP 3",
    title: "OJT研修",
    desc: "ベテラン先輩と一緒に現場に出て実践的に慣れていきます",
  },
];

export default function RecruitTrainingSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section className="bg-white py-16 md:py-24" id="training">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto" ref={ref}>
        <div
          className={`transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <SectionTitle en="TRAINING" ja="安心の研修制度" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-12">
            <div className="h-56 md:h-64 rounded-xl overflow-hidden">
              <img
                src="/images/GRANSTARK-staff5_training_meeting_room.jpeg"
                alt="GRANSTARKの警備スタッフ研修風景"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="h-56 md:h-64 rounded-xl overflow-hidden">
              <img
                src="/images/GRANSTARK-staff8_training_scence.jpeg"
                alt="GRANSTARKの警備スタッフ実技研修"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="relative max-w-4xl mx-auto">
            <div className="absolute left-1/2 md:left-1/2 md:-translate-x-px top-0 bottom-0 w-0.5 bg-gold/30 hidden md:block" />
            <div className="space-y-6 md:space-y-0">
              {steps.map((s, i) => (
                <div
                  key={s.step}
                  className={`relative flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8 ${
                    i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                  }`}
                >
                  {/* SP: 番号＋カードを横並びで被らないように */}
                  <div className={`w-full flex items-start gap-4 md:block md:w-1/2 ${i % 2 === 0 ? "md:text-right" : "md:text-left"}`}>
                    {/* SP用番号サークル（PCでは非表示） */}
                    <div className="flex-shrink-0 w-9 h-9 rounded-full bg-gold border-4 border-white flex items-center justify-center md:hidden" style={{boxShadow: '0 2px 6px rgba(0,0,0,0.15)'}}>
                      <span className="text-white text-xs font-bold">{i + 1}</span>
                    </div>
                    <div className="flex-1 bg-navy/5 rounded-xl p-4 md:p-6 md:inline-block text-left">
                      <span className="text-gold text-xs font-bold tracking-wider block mb-1">{s.step}</span>
                      <h4 className="text-base md:text-lg font-bold text-navy mb-2">{s.title}</h4>
                      <p className="text-gray-600 text-sm">{s.desc}</p>
                    </div>
                  </div>
                  {/* PC用番号サークル（SPでは非表示） */}
                  <div className="hidden md:flex absolute md:left-1/2 md:-translate-x-1/2 w-8 h-8 rounded-full bg-gold border-4 border-white shadow-md items-center justify-center z-10">
                    <span className="text-white text-xs font-bold">{i + 1}</span>
                  </div>
                  <div className="hidden md:block w-full md:w-1/2" />
                </div>
              ))}
            </div>
          </div>

          <p className="text-center text-gray-600 mt-10 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            研修費用は会社負担。「未経験でも、一人前に育てる」というのが私たちのコミットメントです。
          </p>
        </div>
      </div>
    </section>
  );
}